import ApiDevice from '../services/ApiDevice';

import {
    GET_DEVICES_ERROR,
    GET_DEVICES_START,
    GET_DEVICES_SUCCESS,
    TOGGLE_DEVICE_ERROR,
    TOGGLE_DEVICE_START,
    TOGGLE_DEVICE_SUCCESS,
    TOGGLE_DEVICE_PUBLIC_ERROR,
    TOGGLE_DEVICE_PUBLIC_START,
    TOGGLE_DEVICE_PUBLIC_SUCCESS,
    TOGGLE_DEVICE_FORECAST_ERROR,
    TOGGLE_DEVICE_FORECAST_START,
    TOGGLE_DEVICE_FORECAST_SUCCESS,
    UPDATE_DEVICE_START,
    UPDATE_DEVICE_SUCCESS,
    UPDATE_DEVICE_ERROR,
    SET_CURRENT_DEVICE,
    ADD_LOGO_TO_DEVICE_ERROR,
    ADD_LOGO_TO_DEVICE_START,
    ADD_LOGO_TO_DEVICE_SUCCESS,
    GET_RECIPIENTS_START,
    GET_RECIPIENTS_ERROR,
    GET_RECIPIENTS_SUCCESS,
    TOGGLE_REPORTS_START,
    TOGGLE_REPORTS_ERROR,
    TOGGLE_REPORTS_SUCCESS,
    ADD_RECIPIENT_START,
    ADD_RECIPIENT_ERROR,
    ADD_RECIPIENT_SUCCESS,
    REMOVE_RECIPIENT_ERROR,
    REMOVE_RECIPIENT_START,
    REMOVE_RECIPIENT_SUCCESS,

} from './actionTypes';

export const getDevices = () => ({
    async: true,
    errorType: GET_DEVICES_ERROR,
    promise: () => ApiDevice.getDevices(),
    startType: GET_DEVICES_START,
    successType: GET_DEVICES_SUCCESS,
    type: '',
});

export const toggleDevice = (id) => ({
    async: true,
    errorType: TOGGLE_DEVICE_ERROR,
    promise: () => ApiDevice.toggleDevice(id),
    startType: TOGGLE_DEVICE_START,
    successType: TOGGLE_DEVICE_SUCCESS,
    type: '',
});

export const toggleDevicePublic = (id) => ({
    async: true,
    errorType: TOGGLE_DEVICE_PUBLIC_ERROR,
    promise: () => ApiDevice.toggleDevicePublic(id),
    startType: TOGGLE_DEVICE_PUBLIC_START,
    successType: TOGGLE_DEVICE_PUBLIC_SUCCESS,
    type: '',
});

export const toggleDeviceForecast = (id) => ({
    async: true,
    errorType: TOGGLE_DEVICE_FORECAST_ERROR,
    promise: () => ApiDevice.toggleDeviceForecast(id),
    startType: TOGGLE_DEVICE_FORECAST_START,
    successType: TOGGLE_DEVICE_FORECAST_SUCCESS,
    type: '',
})

export const updateDevice = (id, data) => ({
    async: true,
    errorType: UPDATE_DEVICE_ERROR,
    promise: () => ApiDevice.updateDevice(id, data),
    startType: UPDATE_DEVICE_START,
    successType: UPDATE_DEVICE_SUCCESS,
    type: '',
});

export const addLogoToDevice = (id, data) => ({
    async: true,
    errorType: ADD_LOGO_TO_DEVICE_ERROR,
    promise: () => ApiDevice.addLogoToDevice(id, data),
    startType: ADD_LOGO_TO_DEVICE_START,
    successType: ADD_LOGO_TO_DEVICE_SUCCESS,
    type: '',
});

export const setCurrentDevice = (id) => ({
    type: SET_CURRENT_DEVICE,
    payload: id,
});

export const toggleReports = (id, data) => ({
    async: true,
    errorType: TOGGLE_REPORTS_ERROR,
    promise: () => ApiDevice.toggleReports(id, data),
    startType: TOGGLE_REPORTS_START,
    successType: TOGGLE_REPORTS_SUCCESS,
    type: '',
});

export const getRecipients = (id) => ({
    async: true,
    errorType: GET_RECIPIENTS_ERROR,
    promise: () => ApiDevice.getRecipients(id),
    startType: GET_RECIPIENTS_START,
    successType: GET_RECIPIENTS_SUCCESS,
    type: '',
});

export const addRecipient = (id, data) => ({
    async: true,
    errorType: ADD_RECIPIENT_ERROR,
    promise: () => ApiDevice.addRecipient(id, data),
    startType: ADD_RECIPIENT_START,
    successType: ADD_RECIPIENT_SUCCESS,
    type: '',
});

export const removeRecipient = (deviceId, recipientId) => ({
    async: true,
    errorType: REMOVE_RECIPIENT_ERROR,
    promise: () => ApiDevice.removeRecipient(deviceId, recipientId),
    startType: REMOVE_RECIPIENT_START,
    successType: REMOVE_RECIPIENT_SUCCESS,
    type: '',
});



// WEBPACK FOOTER //
// ./src/actions/deviceActions.js